import { lazy } from "react";
import { Outlet } from "react-router";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const DeviceList = ScreenLoader(
  lazy(() => import("../screens/device-screen/DeviceList")),
);

const DeviceCreate = ScreenLoader(
  lazy(() => import("../screens/device-screen/DeviceCreate")),
);

//maping the seller route completely
export const DeviceRoute = () => ({
  path: "device",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: (
        <RoleGuard
          requiredPermission="deviceManagement"
          requiredActions={["isRead"]}
        >
          <DeviceList />
        </RoleGuard>
      ),
    },
    {
      path: "create",
      element: (
        <RoleGuard
          requiredPermission="deviceManagement"
          requiredActions={["isCreate"]}
        >
          <DeviceCreate />
        </RoleGuard>
      ),
    },
    {
      path: "update/:id",
      element: (
        <RoleGuard
          requiredPermission="deviceManagement"
          requiredActions={["isUpdate"]}
        >
          <DeviceCreate />
        </RoleGuard>
      ),
    },
  ],
});
